
import { Button } from "@/components/ui/button";
import ScriptureCard from "@/components/ScriptureCard";
import { Save } from "lucide-react";
import { ScriptureResponse } from "@/hooks/useFindScripture";
import { useAuth } from "@/providers/AuthProvider";

interface ScriptureResultsProps {
  scriptures: ScriptureResponse[];
  loadingStates: Record<string, { commentary: boolean; guidance?: boolean }>;
  onGetCommentary: (id: string) => void;
  onGetGuidance?: (id: string) => void;
  onSaveAll: () => void;
  onSaveItem: (type: 'verse' | 'commentary' | 'guidance', scripture: ScriptureResponse) => void;
  isSaving: boolean;
  prompt?: string;
  autoExpandContent?: boolean;
  hideGuidance?: boolean;
}

const ScriptureResults = ({
  scriptures,
  loadingStates,
  onGetCommentary,
  onGetGuidance,
  onSaveAll,
  onSaveItem,
  isSaving,
  prompt,
  autoExpandContent = false,
  hideGuidance = false
}: ScriptureResultsProps) => {
  const { user } = useAuth();
  
  // Only show save all button if user is logged in and we have scriptures
  const shouldShowSaveButton = user && scriptures.length > 0;
  
  return (
    <div>
      <div className="grid gap-8 mb-6">
        {scriptures.map((scripture) => (
          <ScriptureCard
            key={scripture.id}
            scripture={scripture}
            loadingState={loadingStates[scripture.id]}
            onGetCommentary={() => onGetCommentary(scripture.id)}
            onGetGuidance={onGetGuidance ? () => onGetGuidance(scripture.id) : undefined}
            onSaveItem={onSaveItem}
            hideGuidance={hideGuidance}
          />
        ))}
      </div>
      
      {shouldShowSaveButton && (
        <div className="flex justify-center mb-10">
          <Button
            variant="gold"
            onClick={onSaveAll}
            className="py-6 px-8 text-lg"
            disabled={isSaving}
          >
            <Save className="mr-2 h-5 w-5" />
            {isSaving ? "Saving..." : "Save All Results"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ScriptureResults;
export { ScriptureResults };
